module.exports = __webpack_public_path__ + "img/the-members.f1ed07b4.png";